import { graphql } from '@apollo/client/react/hoc';

import UpdateLinkClickCountMutation from 'buyside/graphql/mutations/UpdateLinkClickCount';

import AdminPost from 'buyside/components/presentation/Feed/AdminPost/adminPost';

const AdminPostContainer = graphql(UpdateLinkClickCountMutation, {
  props: ({ mutate }) => ({
    registerClickedLink: (adminPostId, clickedUrl) => {
      return mutate({
        variables: { adminPostId, clickedUrl }
      });
    }
  })
})(AdminPost);

export default AdminPostContainer;
